'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatSingleOdds = exports.formatOdds = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _formatters;

var _constants = require('@sb/odds-format-common/dist/main/constants');

var _constants2 = require('./constants');

var _constants3 = _interopRequireDefault(_constants2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Converts odds to decimal format given odds numerator and denominator.
 *
 * @param {number} numerator Odds numerator
 * @param {number} denominator Odds denominator
 *
 * @returns {string} formatted odds string
 *
 * @private
 */
var formatDecimal = function formatDecimal(numerator, denominator) {
    var oddsString = numerator + '/' + denominator;
    var decimalRoundingException = _constants3.default[oddsString];

    if (decimalRoundingException !== undefined) {
        return decimalRoundingException;
    }

    return (numerator / denominator + 1).toFixed(2);
};

/**
 * Converts odds to american format given odds numerator and denominator.
 *
 * @param {number} numerator Odds numerator
 * @param {number} denominator Odds denominator
 *
 * @returns {string} formatted odds string
 *
 * @private
 */
var formatAmerican = function formatAmerican(numerator, denominator) {
    if (numerator >= denominator) {
        var _result = 100 * (numerator / denominator);
        return '+' + _result.toFixed(0);
    }

    var result = -100 / (numerator / denominator);
    return result.toFixed(0);
};

/**
 * Converts odds to fractional format given odds numerator and denominator.
 *
 * @param {number} numerator Odds numerator
 * @param {number} denominator Odds denominator
 *
 * @returns {string} formatted Odds string
 *
 * @private
 */
var formatFractional = function formatFractional(numerator, denominator) {
    if (numerator === denominator) {
        return 'EVS';
    }

    return numerator + '/' + denominator;
};

/**
 * Provides appropriate formatter for each odds format. Available formats include: fractional, decimal and american.
 *
 * @type {Object}
 *
 * @private
 */
var formatters = (_formatters = {}, (0, _defineProperty3.default)(_formatters, _constants.ODDS_FORMATS.DECIMAL, formatDecimal), (0, _defineProperty3.default)(_formatters, _constants.ODDS_FORMATS.AMERICAN, formatAmerican), (0, _defineProperty3.default)(_formatters, _constants.ODDS_FORMATS.FRACTION, formatFractional), _formatters);

/**
 * Parses appropriate numerator based on whether or not we want it to be parsed as a float.
 *
 * @param {string|number} numerator Odds numerator
 * @param {boolean} [useDecimalNumerator] Should we parse the numerator as a float
 *
 * @returns {number} parsed odds numerator
 *
 * @private
 */
var parseNumerator = function parseNumerator(numerator) {
    var useDecimalNumerator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (useDecimalNumerator) {
        return parseFloat(numerator);
    }

    return parseInt(numerator, 10);
};

/**
 * Decides if odds are convertable
 *
 * @param {function} formatter Formatting procedure
 * @param {number} numerator Odds numerator
 * @param {number} denominator Odds denominator
 *
 * @returns {boolean} whether or not odds are parsable
 *
 * @private
 */
var canFormatOdds = function canFormatOdds(formatter, numerator, denominator) {
    return !!(formatter && numerator && denominator);
};

/**
 * Converts odds to given format based on odds numerator and denominator.
 *
 * @param {string|number} numerator Odds numerator
 * @param {string|number} denominator Odds denominator
 * @param {string} [format] Odds format
 * @param {boolean} [useDecimalNumerator] Should we parse the numerator as a float
 *
 * @returns {string} formatted odds string
 */
var formatOdds = exports.formatOdds = function formatOdds(numerator, denominator) {
    var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _constants.DEFAULT_ODDS_FORMAT;
    var useDecimalNumerator = arguments[3];

    var numericNumerator = parseNumerator(numerator, useDecimalNumerator);
    var numericDenominator = parseInt(denominator, 10);
    var formatter = formatters[format.toLowerCase()];

    if (!canFormatOdds(formatter, numericNumerator, numericDenominator)) {
        return '';
    }

    return formatter(numericNumerator, numericDenominator);
};

/**
 * Converts odds to given format based on fractional odds string like '2/7'.
 *
 * @param {string} odds Fractional odds string
 * @param {string} [format] Odds format
 * @param {boolean} [useDecimalNumerator] Should we parse the numerator as a float
 *
 * @returns {string} formatted odds string
 */
var formatSingleOdds = exports.formatSingleOdds = function formatSingleOdds(odds, format, useDecimalNumerator) {
    var _odds$split = odds.split('/'),
        _odds$split2 = (0, _slicedToArray3.default)(_odds$split, 2),
        numerator = _odds$split2[0],
        denominator = _odds$split2[1];

    return formatOdds(numerator, denominator, format, useDecimalNumerator);
};